import { getImageFullUrl } from '@/utils/imageUtils';
import { useTranslation } from 'react-i18next';
import { IonImg } from '@ionic/react';
import { IonRouterLink } from '@ionic/react';

type PostLikeNotificationProps = {
  likesData: {
    postId: number;
    imageUrl?: string;
    likesCount: number;
  };
  senderInfo: {
    name: string;
    username: string;
    avatar: string;
  }[];
};

export function PostLikeNotification({ likesData, senderInfo }: PostLikeNotificationProps) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center space-x-4 py-4">
      <IonRouterLink routerLink={`/${senderInfo[0]?.username}`}>
        <IonImg
          src={senderInfo[0]?.avatar || '/placeholder-avatar.png'}
          alt={senderInfo[0]?.name || 'User image'}
          className="size-10 rounded-full bg-muted object-cover"
          style={{ width: '32px', height: '32px' }}
        />
      </IonRouterLink>
      <div className="flex-1">
        <p className="text-sm">
          <IonRouterLink routerLink={`/${senderInfo[0]?.username}`} className="font-semibold hover:underline">
            {`${senderInfo[0]?.name}`}
          </IonRouterLink>
          {likesData.likesCount > 1
            ? (
              <span>
                {' '}
                {t('and')}
                {' '}
                <span className="font-semibold">
                  {likesData.likesCount - 1}
                  {' '}
                  {t('others')}
                </span>
                {' '}
                {t('liked_your_post')}
              </span>
            )
            : (
              <span>
                {' '}
                {t('liked_your_post')}
              </span>
            )}
        </p>
      </div>
      {likesData.imageUrl
        ? (
          <IonRouterLink routerLink="/discover">
            <IonImg
              src={getImageFullUrl(likesData.imageUrl)}
              alt="Post image"
              className="size-10 rounded bg-muted object-cover"
              style={{ width: '32px', height: '32px' }}
            />
          </IonRouterLink>
        )
        : ''}
    </div>
  );
}
